/**
 * internal dependencies
 */
import { formatDateToLocalString } from './common/format-date-localstring';
import { getTransactionsV1 } from '../../routes/get-transactions-v1';
import { displayDashboardTransactions } from './display/display-dashboard-transactions';

/**
 * Dashboard Transactions Table Main
 * This function initializes and manages the dashboard transactions table and related functionalities.
 * 
 * @returns void
 */
const DashboardTransactionsMain = async (): Promise<void> => {
  const transactionTable = document.querySelector('.aafp_transaction-table') as HTMLElement;
  if(!transactionTable) return;

  const date = new Date();
  date.setDate(date.getDate() - 1);
  const dateTwo = new Date();

  const modeldata = {
    startDate: formatDateToLocalString(date),
    endDate: formatDateToLocalString(dateTwo),
    showErrors: 0
  }

  const { body } = await getTransactionsV1(modeldata);
  displayDashboardTransactions(body, transactionTable);
};

export default DashboardTransactionsMain;